import { Box, Stack, useMediaQuery, useTheme } from "@mui/material";
import { ReactNode, useState } from "react";
import ButtonWithUnderline from "../../ButtonWithUnderline";
import BlobWithPreview from "./BlobWithPreview";

const ButtonWithUnderlineWithIcon = ({
  caseStudy,
  children,
  ...props
}: {
  caseStudy: { link: string; image: string };
  children: ReactNode;
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const theme = useTheme();
  const isOverMd = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <Box
      sx={{ position: "relative" }}
      onMouseOver={() => {
        if (isOverMd) setIsVisible(true);
      }}
    >
      <ButtonWithUnderline
        lineStyle={{ height: { md: "4px", xs: "2px" } }}
        defaultUnderlined
        link={caseStudy.link}
        {...props}
      >
        <Stack
          sx={{
            flexDirection: "row",
            alignItems: "center",
            gap: { md: "16px", xs: "8px" },
          }}
        >
          {children}
        </Stack>
      </ButtonWithUnderline>
      <BlobWithPreview
        isVisible={isVisible}
        changeVisibility={setIsVisible}
        caseStudy={caseStudy}
      />
    </Box>
  );
};

export default ButtonWithUnderlineWithIcon;
